// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload-modal {
  width: 50vw !important;
  /* Allow PreUploadFileListTable to take remaining space and scroll */
}
.file-upload-modal .p-dialog-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 10px 30px !important;
}
.file-upload-modal .p-dialog-content {
  padding: 2rem;
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
}
.file-upload-modal .modal-content {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.file-upload-modal .drag-drop-area {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  align-self: stretch;
  border-radius: 0.625rem;
  border: 0.063rem solid var(--stroke, #acacac);
  padding: 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 10rem;
  flex-shrink: 0;
}
.file-upload-modal .drag-drop-area.drag-active {
  border: 2px dashed #003da5;
  background-color: rgba(0, 61, 165, 0.1);
  border-radius: 1rem;
}
.file-upload-modal .drag-drop-area .file-input {
  display: none;
}
.file-upload-modal .drag-drop-area .drag-drop-content {
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.625rem;
  justify-content: center;
}
.file-upload-modal .drag-drop-area .drag-drop-content .upload-icon {
  width: 1.34rem;
  height: 1.34rem;
  margin-bottom: 0.5rem;
}
.file-upload-modal .drag-drop-area .drag-drop-content .drag-drop-text {
  line-height: normal;
  margin: 0;
  font-size: 0.95rem;
  color: #595959;
}
.file-upload-modal .drag-drop-area .drag-drop-content .drag-drop-text .click-here {
  color: #003da5;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
.file-upload-modal .p-dialog-footer {
  padding: 25px 30px !important;
  border-bottom-right-radius: 6px !important;
  border-bottom-left-radius: 6px !important;
}
.file-upload-modal .error-message-wrapper {
  color: #ff0000;
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 1rem;
  margin-bottom: 1rem;
  background-color: rgba(255, 0, 0, 0.05);
  border-radius: 0.4rem;
  flex-shrink: 0;
}
.file-upload-modal .error-message-wrapper img {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
.file-upload-modal .error-message-wrapper .error-message {
  font-weight: 500;
  margin: 0;
  font-size: 0.95rem;
}
.file-upload-modal .pre-upload-file-list-table-container {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.footerbutton-flex {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}
.footerbutton-flex button {
  font-family: inherit;
}
.footerbutton-flex button:disabled {
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/Projects/FilesAndFolder/FileUploadModal.scss"],"names":[],"mappings":"AAAA;EAEE,sBAAA;EA8GA,oEAAA;AA7GF;AACE;EACE,yBAAA;EACA,gCAAA;EACA,6BAAA;AACJ;AAEE;EACE,aAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;AAAJ;AAGE;EAEE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;AAHJ;AAKI;EACE,0BAAA;EACA,uCAAA;EACA,mBAAA;AAHN;AAMI;EACE,aAAA;AAJN;AAOI;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AALN;AAOM;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AALR;AAQM;EACE,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AANR;AAQQ;EACE,cAxEQ;EAyER,iBAAA;EACA,0BAAA;EACA,eAAA;AANV;AAYE;EACE,6BAAA;EACA,0CAAA;EACA,yCAAA;AAVJ;AAaE;EACE,cAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,qBAAA;EACA,cAAA;AAXJ;AAaI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAXN;AAcI;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;AAZN;AAiBE;EACE,SAAA;EACA,aAAA;EACA,gBAAA;AAfJ;;AAmBA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AAhBF;AAkBE;EACE,oBAAA;AAhBJ;AAkBI;EACE,mBAAA;AAhBN","sourcesContent":[".file-upload-modal {\n  $primary-color: #003da5;\n  width: 50vw !important;\n\n  .p-dialog-header {\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #dee2e6;\n    padding: 10px 30px !important;\n  }\n\n  .p-dialog-content {\n    padding: 2rem;\n    overflow: hidden !important;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .modal-content {\n    // padding: 1rem 0;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .drag-drop-area {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 0.625rem;\n    align-self: stretch;\n    border-radius: 0.625rem;\n    border: 0.063rem solid var(--stroke, #acacac);\n    padding: 1.5rem;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    min-height: 10rem;\n    flex-shrink: 0;\n\n    &.drag-active {\n      border: 2px dashed $primary-color;\n      background-color: rgba(0, 61, 165, 0.1);\n      border-radius: 1rem;\n    }\n\n    .file-input {\n      display: none;\n    }\n\n    .drag-drop-content {\n      pointer-events: none;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 0.625rem;\n      justify-content: center;\n\n      .upload-icon {\n        width: 1.34rem;\n        height: 1.34rem;\n        margin-bottom: 0.5rem;\n      }\n\n      .drag-drop-text {\n        line-height: normal;\n        margin: 0;\n        font-size: 0.95rem;\n        color: #595959;\n\n        .click-here {\n          color: $primary-color;\n          font-weight: bold;\n          text-decoration: underline;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n  .p-dialog-footer {\n    padding: 25px 30px !important;\n    border-bottom-right-radius: 6px !important;\n    border-bottom-left-radius: 6px !important;\n  }\n\n  .error-message-wrapper {\n    color: #ff0000;\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n    padding: 1rem;\n    margin-bottom: 1rem;\n    background-color: rgba(255, 0, 0, 0.05);\n    border-radius: 0.4rem;\n    flex-shrink: 0;\n\n    img {\n      width: 24px;\n      height: 24px;\n      flex-shrink: 0;\n    }\n\n    .error-message {\n      font-weight: 500;\n      margin: 0;\n      font-size: 0.95rem;\n    }\n  }\n\n  /* Allow PreUploadFileListTable to take remaining space and scroll */\n  .pre-upload-file-list-table-container {\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n  }\n}\n\n.footerbutton-flex {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n\n  button {\n    font-family: inherit;\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
